import news from "fragments/news/news"
import gql from "graphql-tag"

const GET_DRAFTS_NEWS = gql`
  ${news}

  query getDraftsNews {
    draftsNews {
      ...News
    }
  }
`
export default GET_DRAFTS_NEWS
